import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cnlocale from './zh-cn'
import molocale from './zh-mo'
import en from './en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import enLocale from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'cn',
  messages: {
    cn: {
      ...cnlocale,
      ...zhLocale
    },
    mo: {
      ...molocale,
      ...twLocale
    },
    en: {
      ...en,
      ...enLocale
    }
  }
})
export default i18n
